export default "__VITE_ASSET__DNSP_0i8__"